<div class="pageTitle">
  {{ 'Pay with Crypto Payment' | translate }}
</div>

<div *ngIf="isDepositSuccess" class="pContent success-container">
  <div class="success-icon">
    <img
      src="assets/img/icon/success.png"
      alt="{{ 'Successful' | translate }}"
      width="64"
      height="64"
    />
  </div>
  <h2 class="success-title">
    {{ 'Your deposit has been successfully completed.' | translate }}
  </h2>
  <p class="redirect-message">
    {{ 'Redirecting to merchant' | translate }}<br />
    <span class="countdown">{{ countdown }}</span>
  </p>
</div>
<div *ngIf="!isDepositSuccess" class="pContent">
  <div class="title">
    {{ 'Wallet Address' | translate }}
  </div>
  <div class="wallet-type">
    <img
      [src]="getCryptoIconPath(data.currencyCode)"
      [alt]="data.currencyCode | cryptoName"
      class="wallet-type-icon"
      width="16"
      height="16"
    />
    <span>{{ data.currencyCode | cryptoName }}</span>
  </div>
  <div class="wallet-address-box">
    <span class="wallet-address">{{ data.walletAddress }}</span>
    <button
      class="clipboard-button"
      ngxClipboard
      [cbContent]="data.walletAddress"
      (cbOnSuccess)="alertService.setNotice('Copied to clipboard', 'success')"
    >
      <img src="assets/img/icon/copy.svg" alt="Copy" width="16" height="16" />
    </button>
  </div>
  <div class="text-center">
    <qr-code
      value="{{ data.walletAddress }}"
      size="300"
      errorCorrectionLevel="M"
    ></qr-code>
  </div>
  <div class="waiting-indicator">
    <div class="loading-spinner">
      <div class="loading-dot"></div>
      <div class="loading-dot"></div>
      <div class="loading-dot"></div>
    </div>
    <p class="waiting-message">
      {{ 'Waiting for your deposit to be received in the wallet' | translate }}
    </p>
  </div>
  <div class="currency-exchange-wrapper">
    <div class="currency-exchange">
      <div class="crypto-amount">
        <img
          [src]="getCryptoIconPath(data.currencyCode)"
          [alt]="data.currencyCode"
          class="crypto-icon"
          width="24"
          height="24"
        />
        <span class="crypto">1 {{ data.currencyCode }}</span>
      </div>
      <span class="equals">=</span>
      <div class="fiat-amount">
        <span class="fiat"
          >{{ data.rate | currencyFormat: data.fiatAmountCurrencyCode }}
          {{ data.fiatAmountCurrencyCode }}</span
        >
      </div>
    </div>
  </div>
</div>

<div class="pButton">
  <button class="btn btn-primary" (click)="backToMerchant()">
    {{ 'Back to Merchant' | translate }}
  </button>
</div>
